import { CircleCheck, Hourglass, TriangleAlert } from 'lucide-react'

import { StatusBadge } from '../../../ui/StatusBadge/StatusBadge'
import { pmsPresentation, type AppointmentItem } from '../appointments-model'

/** Whether the clinic's practice system holds a Flio booking yet (Flio bookings only). */
export function AppointmentPmsBadge({
  appointment,
  nowMs = Date.now(),
}: {
  appointment: AppointmentItem
  nowMs?: number
}) {
  const pms = pmsPresentation(appointment, nowMs)
  if (pms === null) return null
  const Icon =
    pms.label === 'In clinic system'
      ? CircleCheck
      : pms.needsAttention
        ? TriangleAlert
        : Hourglass
  return (
    <StatusBadge
      tone={
        pms.label === 'In clinic system'
          ? 'success'
          : pms.needsAttention
            ? 'warning'
            : 'neutral'
      }
      icon={<Icon size={12} aria-hidden="true" />}
    >
      {pms.label}
    </StatusBadge>
  )
}
